import { Component, OnDestroy, OnInit } from '@angular/core';
import { ComponentCanDeactivate } from '@uigy/core/guards/component-can-deactivate';
import type { GetPcapPlayerFilesQuery } from '@uigy/generated/graphql';
import { PcapPlayerGridPageService } from '@uigy/modules/settings/modules/pcap-player/services/pcap-player-grid-page.service';
import { PcapPlayerGridSettingsService } from '@uigy/modules/settings/modules/pcap-player/services/pcap-player-grid-settings.service';
import { AppIdsEnum } from '@uigy/shared/directives/app-id/appIds.enum';
import { TimeUnits } from '@uigy/shared/enums/timeUnits.enum';
import { GridSettings } from '@uigy/shared/modules/grid/models/grid';
import { LanguageService } from '@uigy/shared/services/language.service';
import { Observable, of, Subject, timer } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'app-pcap-player',
    templateUrl: './pcap-player.component.html',
    standalone: false
})
export class PcapPlayerComponent extends ComponentCanDeactivate implements OnDestroy, OnInit {
  public readonly texts = this.languageService.texts;
  public actionsStatus$: Observable<boolean> = of(false);
  public exportCsv$ = this.pcapPlayerGridPageService.exportCsv$;
  public pcapFiles$: Observable<GetPcapPlayerFilesQuery['pcapPlayer']['files']['nodes'][number][]> = this.pcapPlayerGridPageService.PCAPFilesList$;
  public focusedRow?: GetPcapPlayerFilesQuery['pcapPlayer']['files']['nodes'][number];
  public gridSettings: GridSettings<GetPcapPlayerFilesQuery['pcapPlayer']['files']['nodes'][number]> = {
    ...this.pcapPlayerGridSettingsService.gridSettings(),
    actionMenuAppId: AppIdsEnum.pcap_btn_action,
    actionMenu: ([file]) => this.pcapPlayerGridPageService.getActionItems(file, this._disabledActions)
  };
  private _ngUnSubscribe: Subject<void> = new Subject<void>();
  private _disabledActions: boolean = false;

  constructor(private pcapPlayerGridPageService: PcapPlayerGridPageService,
              private pcapPlayerGridSettingsService: PcapPlayerGridSettingsService,
              private languageService: LanguageService) {
    super();
  }

  public ngOnInit(): void {
    this.setPCAPInterval();
    this.actionsStatus$ = this.getActionStatusListener();
  }

  public ngOnDestroy(): void {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  public setPCAPInterval() {
    timer(0, TimeUnits.minute).pipe(
      switchMap(() => this.pcapPlayerGridPageService.fetchPcapFiles()),
      takeUntil(this._ngUnSubscribe)
    ).subscribe();
  }

  public onFocusChanged(focusedRow: GetPcapPlayerFilesQuery['pcapPlayer']['files']['nodes'][number]): void {
    this.focusedRow = focusedRow;
  }

  public uploadPcapFile(formData?: FormData): void {
    if (formData) {
      this.pcapPlayerGridPageService.uploadPcap(formData);
    }
  }

  public canDeactivate(): boolean {
    this.onDeactivate.next();
    return true;
  }

  private getActionStatusListener() {
    return this.pcapPlayerGridPageService.pcapsActionStatus
      .pipe(takeUntil(this._ngUnSubscribe), tap((status: boolean) => this._disabledActions = status));
  }

}
